// 该文件为自动生成，请不要直接修改该文件(直接修改该文件,送翻后修改会失效)
/* eslint-disable */
export default {
  "3259583117": "Notificar Cliente Para Redirecionar",
  "1d484fee4a": "Departamento Financeiro, Departamento de Vendas, Gerenciamento de Projetos, Dados Empresariais, Departamento de Produtos, Departamento de Operações, Gerenciamento de Pesquisa e Desenvolvimento, Planejamento de Versões, Departamento de Atendimento ao Cliente, Departamento Administrativo, Departamento de Compras, Gerenciamento de Pós-venda",
  "a2c88dfb79": "Crie Seu Primeiro Time",
  "3cfdcc6086": "Departamento Financeiro, Departamento de Vendas, Gestão de Projetos/305, Recursos Humanos e Administrativo/306, Departamento de Operações, Gestão de Pesquisa e Desenvolvimento, Planejamento de Versão, Gestão de Atendimento ao Cliente/403, Departamento de Compras, Gestão de Pós-Venda",
  "ac45ec2c05": "Falha na Verificação de Login da Conta",
  "9aef9b8ccd": "Conta Logada Atualmente Anômala, Por Favor, Faça Login Novamente e Tente",
  "728dd00f22": "Número de Telefone Anômalo, Por Favor, Tente Fazer Login Usando Código de Verificação SMS",
  "30dbecd916": "Informação Contém Palavras Sensíveis, Por Favor, Modifique e Tente Novamente",
  "12ed508d8a": "Operação Muito Frequente, Por Favor, Tente Novamente Mais Tarde",
  "952d4a7595": "Estado de Login da Conta Atual Anômalo, Por Favor, Faça Login Novamente e Tente",
  "e64bfdeaa4": "Falha na Verificação de Login, Por Favor, Obtenha Código de Verificação SMS Novamente",
  "79008a65f1": "Este Número de Telefone Já Está Em Várias Empresas, Por Favor, Faça Login em uma Empresa ou Alterar Número de Telefone",
  "bf242eff42": "Nome de Empresa Já Existe",
  "4f0cdb8374": "Por Favor, Insira Número Completo do Telefone, Caso Use Número de Telefone Internacional, Por Favor, Altere para Número Doméstico (86+)",
  "46e79ffeff": "Erro na Criação da Empresa, Por Favor, Contate Suporte ao Cliente para Solução",
  "f3e18f0341": "Erro na Validação de Parâmetro",
  "503fd1718d": "Falha ao Enviar Código de Verificação SMS",
  "24b3129f19": "Envio de SMS Muito Frequente, Por Favor, Tente Novamente Mais Tarde",
  "1cde3e8245": "Código de Verificação Incorreto, Por Favor, Reinsira",
  "4212ecc031": "Várias Falhas de Verificação, Verificação Limitada Temporariamente, Por Favor, Tente Novamente Mais Tarde",
  "735da9c347": "Erro na Verificação de Nomes Similares de Empresa, Por Favor, Contate Suporte ao Cliente",
  "8731da9615": "Erro na Autenticação do Nome da Empresa, Por Favor, Contate Suporte ao Cliente",
  "62e89b3f16": "Concordar com o Acordo de Serviço",
  "c9b79027e5": "Enviar Código de Verificação",
  "84c1447b9d": "Copiado com Sucesso",
  "fba4b0abd0": "Registro do Host",
  "37f5a7cd41": "Valor TXT",
  "78b12427c9": "Autenticando...",
  "59d089837c": "Atualmente Não Podemos Verificar Seu Domínio, Pode Ser Necessário Aguardar um Tempo para Atualizações do Provedor de Hospedagem de Domínio. Se Não Houver Resposta Após um Tempo, Tente Verificar Novamente ou Alterar o Domínio.",
  "4a5b7383d1": "Verificando o registro de validação do domínio",
  "f24a492e40": "Você pode fechar esta página e voltar mais tarde.",
  "c697ca5f1a": "Bem-vindo à versão Enterprise",
  "ebb01b1740": "Próximo Passo",
  "30109bf753": "Sua empresa tem um domínio?",
  "2b3e485b47": "Eu tenho um domínio empresarial",
  "1a7f5eae44": "Eu não tenho um domínio empresarial",
  "bde15d6d84": "Você precisa de um domínio (por exemplo, example.com) para criar uma conta empresarial para você.",
  "07ffb22c90": "Desculpe, você precisa de um domínio para criar uma conta empresarial para sua empresa.",
  "de23836563": "Insira o domínio para o qual deseja criar uma conta empresarial.",
  "287c07944a": "Verifique seu domínio",
  "3ea2d528d5": "Complete os seguintes passos para provar que você é o proprietário do <b>{domain}</b> e impedir qualquer outra pessoa de usar este domínio para registrar uma conta empresarial.",
  "082b18ce56": "a. Abra o site do provedor de hospedagem de domínio em uma <b>nova aba</b> e então <b>faça login</b> na sua conta;",
  "4f7e0841a9": "b. No site do provedor de hospedagem de domínio, vá para a <b>seção de registros DNS</b>. No site do seu provedor de hospedagem de domínio, o nome da seção de registros DNS pode variar, por exemplo, pode aparecer como <b>Gerenciamento de DNS, Gerenciamento de Servidor de Nomes, Painel de Controle ou Configurações Avançadas.</b>",
  "6365ad6e3a": "Em seguida, <b>volte aqui</b> e clique em 'Próximo Passo' para adicionar o registro de validação.",
  "8528892080": "Adicionar registro de validação",
  "7a225304f8": "a. Na página DNS, role até a seção <b>TXT</b> e clique no botão correspondente para adicionar um registro;",
  "b3cb7d947c": "b. <b>Copie e cole</b> todos os valores abaixo no <b>formulário TXT</b> do site do provedor de hospedagem de domínio;",
  "47213583bf": "c. <b>Salve</b> o registro no site do provedor de hospedagem de domínios, <br>e então<b> retorne aqui</b>, e clique abaixo em \"Confirmar Domínio\"",
  "21486a57cf": "Nota: No campo Nome/Host/Apelido, você pode inserir \"@\" ou deixá-lo em branco. O provedor de hospedagem de domínios pode exigir que você insira o nome do domínio (seu domínio.com) neste campo. Talvez você possa determinar como preencher este campo com base em outros registros DNS. No campo Tempo de Vida (TTL), insira \"86400\" ou mantenha o valor padrão.",
  "f1b8edab9c": "Trocar Domínio",
  "7c6fc663a8": "Confirmar Domínio",
  "b6aee9dc0d": "Verificação de Domínio Bem-Sucedida",
  "dd4cc429ea": "Você provou ser o proprietário de",
  "450f5c9230": "e proibiu qualquer outra pessoa de usar este domínio para registrar uma conta empresarial.",
  "71cbcba755": "Clique em \"Próximo\" para concluir a criação da conta empresarial.",
  "f4084f4870": "Defina sua conta de login",
  "fe3138baec": "Concluir Criação",
  "0315cddedb": "Criação da Empresa Bem-Sucedida",
  "91454a7f34": "Agora vá para o painel administrativo para criar contas corporativas para seus membros.",
  "366304cde7": "1. Você será automaticamente desconectado da conta WPS atual.",
  "8a9f2a8422": "2. Você precisa fazer login com a conta corporativa {account}@{domain} no painel administrativo.",
  "43e265e998": "Ir para o painel administrativo",
  "9240efaaf0": "Mensagem de texto enviada",
  "e424bb9a6d": "Por favor, insira",
  "d44d581706": "Nome da Empresa",
  "aa8679f406": "4-30 caracteres",
  "581bdb1f98": "Não pode conter caracteres especiais \\/:*?\"<>|{}",
  "c13cabb67a": "E-mail",
  "2b9b429e46": "Seu e-mail",
  "5ed834a7df": "Digite seu e-mail",
  "acfd1f02ed": "Por favor, insira um e-mail válido",
  "31c7c92cca": "máximo de 80 caracteres",
  "3f27cf84b3": "Insira o código de verificação",
  "a0ae1f3ec4": "Código de verificação incorreto",
  "e5589c5e74": "Seu nome",
  "69d7bd63f6": "Somente caracteres chineses, letras ou números são permitidos.",
  "91f008d258": "máximo de 8 caracteres",
  "6ea6c9b39b": "Telefone",
  "161042c5b7": "Insira o telefone de contato",
  "e6b8eab1cd": "Digite o telefone de contato, 11 dígitos",
  "3fd5fbb3cc": "Insira seu domínio",
  "cb5346ba8e": "Por favor, insira um domínio corporativo válido, 4-30 caracteres",
  "27928eb7a4": "Conta",
  "8e19bd444d": "Digite o nome da conta de login",
  "7bbbf479dc": "4-20 caracteres, apenas números, letras ou sublinhados",
  "3d84cae479": "Por favor, insira uma conta que atenda aos requisitos/o primeiro caractere deve ser uma letra ou número",
  "c0d5ece1a7": "Senha",
  "f444036fa8": "Insira a senha",
  "b03218d72b": "A senha deve ter de 12 a 16 caracteres, combinando letras maiúsculas e minúsculas, números ou outros três tipos de combinações",
  "b4ab05df50": "*Na sua empresa, alguém já usou seu domínio como conta corporativa, entre em contato com o suporte (400-677-5005) para comprovar a propriedade do domínio",
  "c58876008f": "Falha na cópia, por favor tente novamente",
  "86f73420de": "Link de Convite",
  "a58861962c": "Desculpe, seu navegador atual não suporta o download deste código QR",
  "228db07f78": "Departamento Financeiro, Departamento de Vendas, Gestão de Projetos, Dados de Negócios, Departamento de Produtos, Departamento de Operações, Gestão de Pesquisa e Desenvolvimento, Planejamento de Versão, Departamento de Atendimento ao Cliente, Departamento Administrativo, Departamento de Compras, Gestão de Pós-venda",
  "93896d7e98": "Após criar um time, comece a colaborar com colegas",
  "e8f66fb75c": "Departamento de Finanças, Departamento de Vendas, Gerenciamento de Projetos/305, Recursos Humanos/306, Departamento de Operações, Gerenciamento de Pesquisa e Desenvolvimento, Plano de Versão, Gerenciamento de Atendimento ao Cliente/403, Departamento de Compras, Gerenciamento de Pós-venda",
  "831b73da9b": "O nome não pode conter caracteres ilegais e símbolos especiais/\\;:*?\"<>|%&",
  "51ab33b3ee": "Parâmetro incorreto",
  "a297f9e951": "Nome da empresa duplicado",
  "04d60ed5f5": "Não é permitido usar palavras proibidas",
  "2ff7bef083": "Formato de domínio incorreto",
  "41e1ba2165": "Falha na verificação das informações TXT do domínio",
  "50f348caa9": "Conta duplicada",
  "9d4c950d65": "Esse nome já está registrado",
  "38cf19ed95": "Esse nome de instituição já existe",
  "4b426e7c9c": "Nome da instituição",
  "298f880e18": "Já existe, recomendamos que adicione mais informações:",
  "1e67dd20b3": "Recuperar nome da instituição",
  "517107cb04": "Use outro nome",
  "5667081882": "Criar usando este nome",
  "e306a979a6": "Preenchimento rápido:",
  "f583db96e0": "*Caso o nome da instituição esteja ocupado, você pode",
  "9767148e34": "Insira o nome da empresa ou organização, 4~100 caracteres",
  "e0e0ec159f": "Nome da instituição",
  "5b13d254c0": "Este nome de empresa já existe",
  "92027671ec": "Nome da empresa",
  "36d482a7fb": "Recuperar nome da empresa",
  "79058a7577": "*Caso o nome da empresa esteja ocupado, você pode",
  "c96dd48dba": "Nome da empresa",
  "842efad336": "*Se você for um funcionário da empresa, por favor",
  "860f9bd77b": "Atendimento ao cliente",
  "5a7ed18daf": "Ingressar na empresa",
  "ab470e9ace": "Informações de contato reservadas",
  "0a7e0e48a7": "Nome da empresa para solicitar ingresso:",
  "a8dc318dcc": "Por favor, verifique as informações de contato que você forneceu, o serviço ao cliente da plataforma ligará para você em breve",
  "6ea1f4d7f5": "Enviar documentos",
  "d439e39f43": "Recebemos seus documentos",
  "884653426b": "O serviço de atendimento ao cliente entrará em contato com você em 24 horas. Por favor, atenda.",
  "2361cb14bf": "Escaneie o código QR no WeChat para adicionar o atendimento online e acompanhar o progresso.",
  "50f45d0031": "Falha ao salvar",
  "fc856d0fd2": "Super Administrador",
  "e16c0676d2": "Administradores",
  "b1d2ddd126": "Membro Comum",
  "9d322cc08d": "O nome da instituição não pode conter símbolos especiais \\/:*?\"<>|{}",
  "b583ba7363": "O nome da empresa não pode conter símbolos especiais \\/:*?\"<>|{}",
  "1d118a9bad": "O nome da organização deve ter no mínimo 4 caracteres. Por favor, insira um nome de organização entre 4 e 100 caracteres.",
  "441b45b1f5": "O nome da empresa deve ter no mínimo 4 caracteres. Por favor, insira um nome de empresa entre 4 e 100 caracteres.",
  "97457cb1f0": "O nome da organização excedeu 100 caracteres. Por favor, insira um nome de organização entre 4 e 100 caracteres.",
  "8ce00d3b92": "O nome da empresa excedeu 100 caracteres. Por favor, insira um nome de empresa entre 4 e 100 caracteres.",
  "a72778d3de": "O nome deve ter no mínimo 2 caracteres. Por favor, insira um nome entre 2 e 10 caracteres.",
  "79c17db5de": "O nome excedeu 10 caracteres. Por favor, insira um nome entre 2 e 10 caracteres.",
  "482a118202": "O nome só pode conter caracteres chineses, números, letras e ponto médio.",
  "9a9be18941": "Por favor, selecione",
  "e6b7c4aa66": "Termo de Serviço Online",
  "595023d905": "Criar Organização",
  "ba8c2df551": "Criar Empresa",
  "d284384975": "Acordo de Serviços Online",
  "5c266d5a84": "Política de Privacidade",
  "fcb92dbcf6": "Acordo de Serviços de Escritório na Nuvem",
  "2ae7a8a3f7": "Obrigado por escolher os serviços de escritório na nuvem do WPS 365. A seguir, introduzimos o acordo legal celebrado entre você e/ou a organização que você representa e a Kingsoft Office sobre o registro, assinatura e uso deste serviço.",
  "d30a6983bd": "Por favor, leia {0} | {1} | {2}, clique em 'Concordar' para aceitar o conteúdo do acordo e nossos serviços.",
  "263e306ede": "Li e aceito {0} | {1} | {2}",
  "440129c0f1": "Digite {0}",
  "8ab916983d": "Nome da Empresa",
  "b01d68543b": "Seu Nome",
  "684b30d4e9": "Seu Número de Telefone",
  "a48427e8e2": "Para estabelecer a plataforma de trabalho para sua empresa",
  "3a81b0f1fc": "Para facilitar que seus colegas lhe encontrem no sistema e colaborem no escritório",
  "52bc539b6e": "Confirmar Criação",
  "b2fe245e19": "Criar empresa/equipe: Compartilhamento e colaboração de arquivos",
  "893282d3f7": "Por favor, complete as informações da empresa:",
  "cc997bf6aa": "Confirmar",
  "50fdde51ac": "{0}, {1} a {2} dígitos",
  "a19cc5ec18": "{0}, não pode conter caracteres especiais \\u005C/:*?\"<>|{}",
  "26857f28f9": "{0}, apenas caracteres chineses, letras e números permitidos",
  "f4080b1431": "{0}, no máximo {1} caracteres",
  "88e59b2d58": "{0}, 11 dígitos numéricos",
  "91d6d4e105": "Por favor, insira o código de verificação",
  "bec71bde96": "Código de verificação incorreto",
  "e20ff8ee19": "{0} é obrigatório",
  "8dc09d10d7": "Não foi possível encontrar dwId",
  "a03766ce6c": "Escola",
  "03542addfe": "Empresa",
  "adb8a815d1": "Limite atingido para {0} no número de celular vinculado",
  "97a6b66f1d": "O número de celular atual já está vinculado a {0}",
  "665e465487": "Não foi possível criar {0}. O número atual de telefone celular \"<strong>{1}</strong>\" atingiu o limite máximo de vinculações de {0} (máximo de 5 {2}). Você pode acessar os {3} vinculados abaixo:",
  "a85b1367ca": "O número de celular atual \"{0}\" já possui {1} vinculado. Você pode escolher fazer login com um {2} existente ou criar um novo {3}:",
  "bf992ce17b": "Criar {0} usando outro número de celular",
  "395ea04444": "Criar novo {0}",
  "4ce3bb86b3": "Número máximo de {0} atingidos",
  "df88c4b7a5": "O número de celular atual \"{0}\" atingiu o limite máximo de {1} vinculados",
  "78f7dd59ca": "O número de celular atual \"{0}\" tem os seguintes {1} vinculados e pode ser alternado diretamente:",
  "8db491a3f8": "Continuar criando novo {0}",
  "83f6d9e1e4": "Tentar novamente",
  "1dc5f11612": "ou",
  "217d76f53e": "Qualificações",
  "b69a6ea62a": "Por favor, mantenha pressionado o botão esquerdo do mouse para raspar dois escudos",
  "3a31f64800": "Parabéns, você raspou com sucesso o escudo<br/>Continue para a próxima etapa",
  "6a81fcee96": "Carregando",
  "e97877a65d": "Ops, o escudo desapareceu<br/>Por favor",
  "8d85456145": "Esperei muito tempo<br/>Por favor",
  "77ad847b95": "A conexão está muito fraca<br/>Por favor",
  "dbd1ae3a34": "Você raspou muito rápido<br/>Por favor",
  "bd8e05cd53": "Clique no botão para iniciar a verificação inteligente",
  "63d2a8a722": "Verificação bem-sucedida",
  "73141928ad": "Falha na verificação, clique no botão para atualizar",
  "04856c5c8a": "Detecção inteligente em andamento",
  "52cd9bd26d": "Sua operação não está autorizada",
  "fd157e8ea8": "Guia de criação",
  "c6225c5b2b": "Bem-vindo à versão empresarial",
  "e33423fb1e": "Criação concluída com sucesso",
  "7b0c035999": "Página de criação bem-sucedida dos Documentos Empresariais da Jinshan",
  "85db8faae0": "Guia de uso da versão empresarial",
  "20591b9b44": "Recuperar o nome da empresa",
  "b023d76dc2": "Guia de upload para membros",
  "e2f454e095": "Empresa de {0}",
  "df466f942b": "Subsidiária",
  "26a7b797c4": "Centro de divisão",
  "5fc82b360b": "Plataforma de serviços de escritório tudo-em-um para melhorar sua eficiência",
  "f2e736d52e": "Bem-vindo à versão empresarial",
  "becc41a35b": "Nome da empresa",
  "74685cdc58": "Por favor, insira o nome da empresa ou organização, 4 a 100 caracteres",
  "07b55b1907": "Escala Empresarial",
  "77b2f763ad": "Por favor, selecione a escala de sua empresa",
  "49d2509109": "Menos de 5 pessoas",
  "8db2c9b74a": "6-20 pessoas",
  "a9fb0cf14a": "21-50 pessoas",
  "0fed41f8d3": "51-100 pessoas",
  "fb33f25a04": "101-200 pessoas",
  "3e3ff0f52e": "201-500 pessoas",
  "cd8b51f634": "501-2000 pessoas",
  "0662fa6eec": "Mais de 2000 pessoas",
  "69334dba1a": "Necessidades da Empresa",
  "79994e749c": "(Recomendaremos as melhores soluções práticas para o setor)",
  "840a017f38": "Por favor, selecione o problema que deseja mais resolver",
  "f045b05c73": "Por favor, insira suas necessidades para a criação da empresa",
  "d8efb0b36d": "Mais",
  "adcb8fbb0c": "Número de telefone comum",
  "eb1c73e2ca": "Por favor, insira seu número de telefone de 11 dígitos",
  "7f276e7dfa": "Criar Gratuitamente",
  "c391b3eec1": "Falha ao enviar SMS",
  "54f4cb8fa7": "SMS enviado",
  "231eb1fa1e": "Usuário Corporativo {0}",
  "272b0f9d32": "Utilizador da versão Enterprise",
  "b209a67331": "Falha ao criar empresa, por favor, atualize a página.",
  "acb08d0cc9": "Terceira etapa da criação da empresa",
  "83db361f51": "Após a conclusão, ativar a lógica de redirecionamento",
  "1e930326e3": "handleStep entrar no próximo passo",
  "184df5c725": "Falha ao guardar o formulário",
  "736eab3023": "Enviar validação",
  "2db62dc13c": "Falha na validação",
  "54fb0afaea": "Validação bem-sucedida",
  "d39cff3fcf": "Pular salvamento extremo para verificar se é necessário o código de verificação",
  "305b777ae5": "Falha na verificação do nome, ativar pop-up \"Nome da empresa é utilizado\" e armazenar o nome",
  "e57b6686b2": "Verificar se o sujeito certificado já foi autenticado, abrir pop-up de aviso de proteção de certificação e armazenar informações do sujeito certificado correspondente",
  "f7c86f496d": "Nome criado em duplicado || Código de verificação expirado Se qualquer condição falhar, impedir a execução",
  "cb37db4fd4": "Falha no handleSubmit",
  "243a569fc4": "Este nome já está registrado, por favor, use outro nome",
  "196851a3d9": "Usuário Corporativo {0}",
  "0c3a3595ff": "Utilizador da versão Enterprise",
  "a33b41e0f2": "Falha ao criar empresa, por favor, atualize a página.",
  "fcce6a7156": "Criação bem-sucedida",
  "5ec6da58a6": "Notificar o cliente",
  "259c9dfa4e": "Lógica da versão profissional",
  "864156930f": "Lógica vba",
  "7824efd172": "AirPage para dispositivo móvel",
  "52b6cfaaaf": "Cliente WPS",
  "c7c51beea9": "Versão Educativa",
  "8d054d4986": "Cliente padrão",
  "b597e18fb1": "isWps365PcClient e com openurl",
  "b0c13de2a0": "isWps365PcClient ou não cliente, com openurl",
  "7d0f2ce18c": "isWps365PcClient ou não cliente, com openurl sucesso em retorno de chamada",
  "e2c5a07df6": "não cliente não openurl",
  "29e0414d1f": "não cliente não openurl Callback",
  "60861f7d2a": "autoChange entregue à parte de negócios para alternar",
  "7c83140d90": "Estado visitante criado, não precisa passar pela alternância de conta SDK (SDK não suporta visitante), código já alternou com sucesso",
  "3379b09e59": "tem openurl e usa href para alternar",
  "586ff04c22": "salto separado",
  "b6c91f218b": "useSuccessSkip falhou",
  "47d2f3ba66": "Mais",
  "57551f86ce": "Métodos diferentes de redirecionamento com base no utm_source",
  "64fe3758e2": "Sua ação não está autorizada",
  "4da3e1262f": "Criação bem sucedida, comece sua jornada de escritório empresarial",
  "c38dfb8c6c": "Crie seu primeiro Equipe",
  "38dddb483b": "Entre em Empresa",
  "614d9c91eb": "Convide membros para ingressar",
  "97f1eca0aa": "Entre em Empresa",
  "13a4939e90": "Convite para entrar na empresa",
  "a319e4ae0a": "Convide colegas para ingressar",
  "12e4da6bba": "Convide colegas imediatamente",
  "bd885380f6": "Falha ao obter link de convite",
  "5e626c4063": "SMS enviado",
  "3dc09e7cfd": "O número de nomes de empresas que você solicitou para recuperar atingiu o limite máximo",
  "48318f41f9": "Convide membros para ingressar",
  "45441baac4": "Convido você para colaborar em {0}",
  "e5847fbd67": "Copie o link, convide membros",
  "23101dd40a": "Estamos personalizando a solução para você",
  "71bb7e54a8": "Gestão de Projetos",
  "aff37c79cc": "Experimente a solução selecionada",
  "a97b174258": "Convide mais <color: red>2</> colegas para acessar gratuitamente os seguintes benefícios corporativos",
  "253855849f": "Compartilhe o link de convite no grupo de trabalho para convidar colegas",
  "57b0a2a63f": "Copie o link, convide colegas",
  "71c0a37ee1": "Entre em Empresa",
  "f848c60e0e": "Convide mais <color:red>2</> colegas para acessar gratuitamente os seguintes benefícios corporativos",
  "664e32b4fe": "Página de convite Entre em Empresa",
  "872f14403a": "Convide colegas para ingressar",
  "1880e7deb9": "Convide colegas imediatamente",
  "cc2a9aaf82": "Criação bem sucedida",
  "02a13e2583": "Convide mais <color: red>2</> colegas para acessar gratuitamente os seguintes benefícios corporativos",
  "5d3593cdce": "Falha ao obter informações da equipe",
  "c025113ea1": "Falha ao obter link de convite",
  "b83bc1e485": "Convite por link",
  "0996ced9f6": "Desculpe, seu navegador atual não suporta baixar este código QR",
  "1e88451e31": "Link de convite copiado",
  "bb969cabcd": "Falha ao copiar, por favor, tente novamente",
  "15e1f79c7a": "Solicitar ingresso na empresa",
  "59c22b4ef8": "Recebeu um link de convite",
  "0f0b392e60": "Crie o Seu Primeiro Equipe",
  "0437d07c43": "Nome da Empresa",
  "41800c7bf1": "Insira o Nome do Criador",
  "1ec5999511": "O Nome do Criador Pode Ter Até 8 Letras",
  "02da35b4e4": "O Nome do Criador Só Pode Incluir Caracteres Chineses, Letras e Números",
  "184e9f6616": "Insira o Telefone de Contato",
  "9b587898ba": "Insira o Telefone de Contato no Formato Correto",
  "e68c164a02": "Insira o Seu Email",
  "0b1de22df7": "Insira o Email no Formato Correto",
  "61026181ab": "Licença de Operação é Obrigatória",
  "c3847e604e": "O Tamanho do Arquivo Excede 10 MB, Por Favor Selecione Outra",
  "49450f4ec7": "Formulário de Apelação de Nome Requerido",
  "39c3b8fa1d": "Envio Falhou",
  "3ea44d7963": "Upload Concluído",
  "5b1aa3c2c4": "Upload Falhou",
  "7e7f81eaa3": "Upload Falhou, Arquivo Maior que 10 MB",
  "2ff1913de1": "Upload Falhou, O Arquivo Deve Ser .jpg, .jpeg, .png, .bmp, .pdf",
  "7951a879f2": "Licença de Operação é Obrigatória",
  "66bda65057": "O Tamanho do Arquivo Excede 10 MB, Por Favor Selecione Outra",
  "8f2305a83d": "Formulário de Apelação de Nome Requerido",
  "55ff0c8c6e": "Envio Falhou",
  "8dad6d950d": "Falha ao Obter Informação de Convite",
  "a5f0ac3a9a": "Criação Concluída",
  "4f1d069770": "Os Parâmetros utm da Página de Convite São {0} e Nome {1}",
  "f9578cfe6d": "Os Parâmetros utm da Condução em Dois Passos São {0} e Nome {1}",
  "e10d028405": "Duas etapas de orientação PCOffice criado",
  "8e22e4fcc4": "Link de Convite Copiado",
  "3f327f9f37": "Falha ao Copiar, Por Favor Tente Novamente",
  "bd1aecb265": "Cancelar",
  "b6abf9b19a": "Concordo",
  "e910d9cc0f": "Cancelar",
  "37ab25522d": "Concordo",
  "196b3eb9cf": "Escaneie o Código para Entrar",
  "2b81c52e20": "Baixar Imagem",
  "62152fd9f3": "Convite por Link",
  "e0a3725651": "Desculpe, Seu Navegador Atual Não Suporta o Download deste Código QR",
  "8b7883b2c7": "Escaneie o Código para Entrar",
  "9e9a659ed5": "Baixar Imagem",
  "0d55065a9a": "Convite por Link",
  "487cf6a106": "Desculpe, Seu Navegador Atual Não Suporta o Download deste Código QR",
  "78fd005d1f": "Insira o Número de Telefone",
  "f909563857": "Use Este Número para Criar",
  "a26a19f139": "Cancelar Criação",
  "cc004ac9ee": "Número de Telefone",
  "4df8c3c588": "Insira Outro Número para Criar Escola",
  "3151cabb3d": "Insira Outro Número para Criar Empresa",
  "56098a71eb": "Clique em Verificação Inteligente, Enviar Código de Verificação",
  "e96ec218e4": "Insira o Código de Verificação por SMS",
  "ce619a0225": "Código de Verificação por SMS Enviado para",
  "0e9863aaeb": "Código de Verificação Incorreto, Por Favor Insira Novamente",
  "32dc8629e1": "Segundos para Reenviar",
  "e4eda9add5": "Voltar a Enviar",
  "b007977564": "Falha ao Obter Informação de Aprovação",
  "d8852ffc9c": "Acesso Não Autorizado",
  "8a733a2574": "Acesso Móvel",
  "9e8c152c4f": "Acesso em PC",
  "2265a55e93": "Concordar com os Termos de Serviço",
  "80dabe5aa3": "Criar Guia",
  "7deee8bf5a": "Guia de Duas Etapas DocsWeb Criado",
  "69eb501ecb": "Sua contestação tornou-se inválida, não é possível acessar",
  "aa1d9d98ad": "Permissão insuficiente, não é possível acessar",
  "fdf2fe129e": "Criar Instituição",
  "7f0ca0df6b": "Criar Empresa",
  "cc6ac2a93c": "Guia de Dois Passos Base montado",
  "5d6c570bf0": "Guia de Dois Passos antesdesaída",
  "a4eb8a192d": "Equipes que todos estão criando",
  "4912e16a9d": "Nome da empresa recuperado",
  "41c4e87ef2": "Você pode clicar no link",
  "5e630930c0": "Recriar Empresa",
  "436a563524": "Se você já criou uma empresa, você pode consultar",
  "0b6e7cbe7f": "Como Alterar Nome da Empresa",
  "cb7bce0775": "Tutorial para modificar o nome da empresa",
  "3feadd3040": "Versão atual muito baixa, incapaz de usar a empresa",
  "3cf23de936": "Sua versão do software está muito baixa, a funcionalidade empresarial não pode ser usada. Por favor, vá ao mercado de aplicativos para atualizar a versão do software!",
  "a1c5d5d202": "OK",
  "e50183bd00": "WPS Cloud",
  "e5031ab679": "Segurança, Sincronização, Colaboração",
  "c870026dfc": "Login do Wechat",
  "e7647cd875": "Login do WPS Account",
  "07b380074b": "Login do QQ",
  "67921724dd": "Outras formas",
  "254da8a9f5": "Número máximo de empresas/join alcançado",
  "3648e4811b": "Acessar AirPage",
  "dcd102b346": "Criação de equipe personalizada",
  "8b9b258cbf": "Digite o nome da equipe aqui",
  "19bb6e0ded": "Membros WPS têm",
  "2d9fe8d938": "Vários benefícios de escritório, ajudando a resolver os problemas de documentos do dia-a-dia, venha experimentar!",
  "e8c1caa649": "Carregar do Local",
  "03641083a3": "Mover de 'Documentos Pessoais'",
  "eecd3ab9b5": "Dizer da Próxima Vez",
  "13b447b3a8": "Substituir",
  "3c2fc507fc": "Versão atual muito baixa, incapaz de usar a empresa",
  "c3615d8134": "Sua versão do software está muito baixa, a funcionalidade empresarial não pode ser usada. Por favor, vá ao site oficial para atualizar a versão do software!",
  "644a36e05b": "Atualizar",
  "d435105f21": "Número máximo de empresas/join alcançado",
  "73a286ceb0": "Acessar AirPage",
  "c2cec645c0": "Cancelar",
  "b5f5b83c0f": "Concordo",
  "76ec352da5": "Convite QR para colegas",
  "6a509e4487": "Baixar código QR",
  "940cc4a546": "Incapaz de criar empresa",
  "78b2a62ea5": "Entre em uma empresa existente ou crie uma nova",
  "3a6da7f6f9": "Número de empresas vinculadas ao número de telefone atingiu o limite (máximo de 5 empresas)",
  "93bab52870": "Seu número de telefone já está vinculado a uma empresa, você pode escolher entrar na empresa existente:",
  "ce6e0adaf2": "Você pode escolher entrar na empresa vinculada abaixo:",
  "1ce200a92b": "Selecionar",
  "bb91ef2999": "Criar Nova Empresa",
  "024e4a91e5": "Nome da empresa já registrado",
  "eb089a23a0": "Nome da empresa já registrado:",
  "7646558701": "Administrador:",
  "1d9c02bd33": "Hora de Registro:",
  "919fc7805f": "Sugerimos que você tente encontrar e entrar em contato com seus colegas acima.",
  "0ca71a9344": "Você também pode usar outro nome temporariamente para criar a empresa (pode ser alterado posteriormente) e, em seguida, enviar uma contestação.",
  "e83a244e90": "Clique para saber como contestar.",
  "d22bedfb21": "OK",
  "907b78b6e5": "Insira o nome do grupo de trabalho ou equipe",
  "7195b0ac1e": "Equipes que você pode querer criar",
  "60ed4f915e": "Próximo",
  "f5ba8dfb7b": "Pular Introdução",
  "5c44a3ef68": "Máximo de 100 caracteres",
  "130c53fb20": "Nome não pode conter caracteres ilegais e símbolos especiais/\\;:*?\"<>|%&",
  "e832d41acc": "Guia de Dois Passos Pular",
  "80d9cf7177": "Guia de Dois Passos Atualizar",
  "0aebf80435": "Guia de Dois Passos Clique no Label",
  "e74f515977": "Como Submeter em Dois Passos",
  "308d2a53c9": "Guia de Dois Passos criarGrupo",
  "dda2ed7e18": "Guia de Dois Passos Falha ao Criar Equipe",
  "ded3c35500": "Falha ao Criar Equipe",
  "4f18031bc1": "Guia de Dois Passos criarTemplate",
  "091e5cefcc": "Guia de Dois Passos erro ao criarTemplate",
  "58cf4e00f0": "Código de Verificação",
  "92abbf0385": "Enviar Código de Verificação",
  "f0f9976ef9": "Por favor, insira o número de telefone",
  "a4ce99b1df": "Código de Verificação",
  "39d36e0f9f": "Confirmar",
  "0fd8a01938": "Enviar",
  "9048a4e842": "Número de Telefone",
  "9afa1091eb": "Reenviar",
  "58d787001f": "Insira outro número de telefone para criar escola",
  "450905a265": "Insira outro número de telefone para criar empresa",
  "f7386de3c6": "Selecione no Menu Suspenso",
  "27aa05a92c": "Concordo com os Termos de Serviço",
  "80af61cb57": "Voltar Página Anterior",
  "50149b8d4f": "Nome do Solicitante",
  "e6756f8749": "Por favor, insira seu nome",
  "3cbd51a2b1": "O nome deve ter no mínimo 2 caracteres, insira um nome de 2 a 10 caracteres",
  "4f79b4813f": "Nome apenas suporta caracteres chineses, números, inglês e ·",
  "71d3e75983": "Número de Telefone Comum",
  "afe5149035": "Por favor, insira seu número de telefone comum",
  "1e9270b50f": "Por favor, insira seu número de telefone comum, 11 dígitos",
  "ff5dc98dfb": "Pular",
  "165be2ab43": "Voltar Etapa Anterior",
  "231d8a335a": "Concordo com os Termos de Serviço",
  "1cad008ffc": "O nome da empresa {0} já foi registrado, use outro nome",
  "c6e274fcab": "Confirmação do Acordo",
  "b9352504bb": "Fechar Janela do Acordo",
  "8409e99ad0": "Abrir Janela do Acordo",
  "1593c6dd95": "Enviar",
  "4f44a9de22": "Abrir Verificação de SMS",
  "26b70c68b8": "Pular, Entrar Diretamente na Empresa",
  "a8bebcb302": "Voltar Página Anterior",
  "c800b4fec5": "Página de Convite Base Montada",
  "38b396d5b0": "Página de convite, docsWeb montado",
  "2eb7f9a9f1": "Sua apelação foi enviada com sucesso",
  "2c6f3590fb": "Esperamos enviar o resultado do processamento para seu e-mail em até 3 dias úteis",
  "2ea3eff708": ",Por favor, verifique.",
  "53acfba22c": "Convide Colegas Imediatamente",
  "4e6d282f4f": "Convite para Entrar na Empresa",
  "5f72f4b936": "Convide Colegas Imediatamente",
  "e5383077ba": "Recuperar Nome da Empresa",
  "06e3fa2350": "Após consulta,",
  "653a263b5e": "O criador é",
  "769f57269f": "O número de telefone do criador é",
  "09a224695e": "Por favor confirme se o criador desta empresa é seu colega",
  "3beda6c149": "Se for seu colega, você pode contatá-lo",
  "5c74dd10d1": "Modificar o nome da empresa ou transferir o super administrador.",
  "da504edb0f": "Se não for seu colega, você pode clicar no botão abaixo para continuar recuperando o nome da empresa.",
  "39194faaf1": "Continuar recuperando o nome da empresa",
  "e22b829e90": "Copiado com sucesso",
  "6e1b44752a": "Valor TXT",
  "79881b1d7a": "Convidar colega agora",
  "a5344a45f9": "Clique no canto superior direito, selecione 'Enviar para amigos'",
  "a4954a5b08": "Convidar colega agora",
  "8e3a1625fb": "Recuperar nome da empresa",
  "bf8b8c7005": "Upload da licença de operação da empresa",
  "bfd44a66c9": "Clique para selecionar",
  "d503f20925": "Por favor, faça o upload do escaneamento ou foto da licença de operação da empresa",
  "cbebe043c5": "Suporta formatos JPG, JPEG, PNG, BMP, PDF, não superior a 10 MB.",
  "9650b96d7d": "Upload do formulário de apelação de nome duplicado",
  "c3b8ae46d3": "Por favor, faça o upload do escaneamento ou foto do formulário de apelação de nome duplicado",
  "9e325a9e09": "Baixar modelo de formulário de informações",
  "a4711aae88": "Submeter pedido",
  "3a5cc1441e": "Autenticando...",
  "0bd7bf8511": "Atualmente não podemos verificar seu domínio, você pode precisar esperar um pouco mais para o provedor de hospedagem do domínio atualizar suas informações. Se não houver resposta após algum tempo, tente verificar novamente ou altere o domínio.",
  "fae48d554b": "Verificando o domínio",
  "5e1779a0ca": "dos registros de verificação, você pode fechar esta página e retornar mais tarde para verificar.",
  "ca85f8b836": "Bem-vindo à versão empresarial",
  "2570e0f00b": "Falha de login",
  "40d16a007e": "Sua conta pessoal foi automaticamente vinculada",
  "81376b92e4": "método de login de {0}, por favor, faça login novamente para mudar para a conta empresarial.",
  "ba679ba739": "Entendido, ir para login",
  "c05f64c6c6": "Depois de {0}, vá automaticamente para o login",
  "c329ccef3a": "Falha de login",
  "e370f9afb1": "Sua conta pessoal foi automaticamente vinculada",
  "410cf42585": "Para fazer login, por favor, saia e entre novamente usando a conta empresarial.",
  "062d48aece": "Entendido, ir para login",
  "95a105d412": "Depois de ir automaticamente para login",
  "2d000d5a6d": "Enviar link de compartilhamento para membros, membros podem solicitar adesão após abrir",
  "8861b6e90d": "Entrar na empresa",
  "25b9f72fda": "Erro de parâmetro de página",
  "1c76123efc": "Falha ao obter link de convite",
  "6caba48b76": "Pular",
  "f66379c650": "Erro de parâmetro de página",
  "c45021de2a": "Criação falhou",
  "011d470126": "A plataforma continua a proteger a segurança das suas informações",
  "f1a44d9151": "A plataforma obteve certificados ISO27001 e ISO27701 emitidos pela BSI internacional e passou na avaliação de segurança de nível três nacional",
  "255ea5dff7": "White Paper de Segurança",
  "bb55b124f2": "Criar Apresentação Empresarial",
  "61e24974a3": "Criar Conteúdo Estratégico de Aquisição Empresarial",
  "bfdf78febe": "Próximo Passo Complete as Informações",
  "c4aa2d2d60": "Digite o nome do grupo de trabalho ou projeto",
  "b69765ab64": "Equipe que Todos Estão Criando",
  "9657d9408b": "Substituir",
  "e21da8c16a": "Próximo",
  "224ef5cc9f": "Pular Introdução",
  "641f58c8f6": "A empresa atual não permite que membros criem equipe, por favor pratique com o administrador para criar",
  "efea622752": "Copiar Link, Convidar Colegas",
  "fd5b40a9fd": "Convidar você a se juntar a \"{0}\", colabore conosco",
  "b04dd2f10a": "Link de Convite Copiado",
  "d1606a1b1a": "Falha ao Copiar, Por Favor Tente Novamente",
  "0d59f3db83": "Digite o setor ou equipe do projeto, como 'Departamento de Vendas'",
  "9429513d34": "Não Precisa de Introdução",
  "b54a20b1ff": "Falha ao Criar",
  "093fa0fb74": "Autorização de Login...",
  "b383b136f4": "Inicialização do Projeto Empresarial",
  "b6b21b388b": "Nome da Empresa Já Registrado",
  "285dc68c10": "Este Nome de Empresa Já Está Registrado:",
  "1bf685b89d": "Administrador:",
  "7b4297edcc": "Data de Registro:",
  "fa51ea19fc": "Recomendamos que você procure e entre em contato com os colegas mencionados acima.",
  "e3678a996d": "Você também pode usar temporariamente outro nome para criar a empresa (pode ser alterado no futuro) e, em seguida, enviar uma apelação.",
  "5969bc8071": "OK",
  "ba4cf699df": "Recuperar Nome da Empresa",
  "afecee4eb4": "Seu Nome",
  "a8bdebc614": "Por Favor, Insira Seu Nome",
  "5bbeb38a66": "Telefone",
  "b4f7b44b7a": "Por Favor, Insira Seu Telefone de Contato",
  "cac2913686": "Email de Contato",
  "23d3bb3a42": "Por Favor, Insira Seu Email de Contato",
  "ea106a393c": "Carregar Licença Comercial da Empresa",
  "f74131d71e": "Clique para Selecionar",
  "53749c51c5": "Por Favor Carregue o Escaneamento ou Foto da Licença Comercial da Empresa",
  "c00f2ea171": "Compatível com Formatos JPG, JPEG, PNG, BMP, PDF e Tamanho não Superior a 10 MB.",
  "57ec07fa97": "Carregar Formulário de Apelação de Nome Duplicado",
  "8eb0606e94": "Por Favor Carregue o Escaneamento ou Foto do Formulário de Apelação de Nome Duplicado",
  "f59e76c0b0": "Baixar Modelo de Formulário",
  "030bd26fa4": "Enviar Pedido",
  "0a602dc727": "Armazenamento Seguro de Dados",
  "9138f28acf": "Compartilhamento de Arquivos e Colaboração",
  "b3a306cf90": "Licenciamento em Conformidade",
  "973c53f725": "Recomenda-se Modificar o Nome, Após o Registro é Possível Submeter Certificação da Instituição e Atualizar o Nome",
  "f886f5e92f": "Recomenda-se Modificar o Nome, Após o Registro é Possível Submeter Certificação da Empresa e Atualizar o Nome",
  "b8051702a3": "O Nome Contém Palavras Sensíveis, Por Favor Ajuste o Nome ou Entre em Contato com o Atendimento ao Cliente",
  "d73881f7d4": "Nome da Empresa Protegido",
  "dc7e58e320": "Nome da Empresa Protegido, Requer Verificação da Informação Principal Antes do Uso. Recomenda-se Modificar o Nome da Empresa, ou Após o Registro, Usar o Nome Através de Certificação Empresarial.",
  "20c3bc070c": "Confirmar",
  "c4278e5f28": "Permissão insuficiente",
  "9217efae21": "A conta com que você fez login não tem permissão para criar. Por favor, entre em contato com o pessoal de vendas.",
  "52ff08f2ad": "O nome da instituição está protegido. Por favor, ajuste o nome da empresa.",
  "79386ae280": "Digite o código de verificação de 6 dígitos",
  "d7b2c5a41b": "Código de verificação enviado para",
  "ce2e1c26f7": "(Válido por 10 minutos)",
  "59d338903f": "Código de verificação disponível novamente em {0} segundos",
  "5aadd14136": "Obter código de verificação novamente",
  "90f5c93432": "Este nome já está registrado",
  "1677072f4a": "Você pode completar mais informações ou usar outro nome para registrar",
  "3b8459fb1e": "Preenchimento rápido:",
  "6f38edbcb1": "Registrar com este nome",
  "8406c81e2d": "Filial",
  "29d323fa85": "Centro Regional",
  "4f0e806e02": "Departamento Financeiro",
  "3f935efb6b": "Concordo com o Acordo de Serviços",
  "b42241be05": "Ainda não",
  "99de4b33b7": "Concordo",
  "7f867e7395": "Usar outro número de telefone para criar uma empresa",
  "0d51a8f7a6": "Continuar criando",
  "8bdaecf2e5": "Digite seu número de telefone",
  "565ae60c8a": "Digite seu nome",
  "f76e06d0e7": "Digite seu número de telefone",
  "7b0fca5255": "Digite o código de verificação",
  "68026d2d25": "Bem-vindo à versão empresarial",
  "d25b5541be": "Criação gratuita",
  "32cfd73733": "Digite o nome do time, empresa ou organização",
  "4cf83dc4a0": "Criação rápida em um minuto, colabore eficientemente com colegas",
  "d320d37116": "Criação gratuita de equipe/empresa",
  "c54b475dd2": "Acordo de Usuário",
  "190d54e616": "Empresa de {0}",
  "8c1b768ac4": "Falha na verificação inteligente",
  "d74eab0f35": "As informações sobre o nome da sua empresa não estão de acordo com as normas da plataforma. Por favor, modifique e tente novamente.",
  "0f3d62dd4f": "As informações sobre o preenchimento do seu nome não estão de acordo com as normas da plataforma. Por favor, modifique e tente novamente.",
  "647cf2211b": "Não é possível criar com o número de telefone atual, por favor, altere o número.",
  "b63d96cdae": "As informações preenchidas não estão de acordo com as normas da plataforma. Por favor, modifique e tente novamente.",
  "2dbbe8e43f": "Não é possível criar com o número de telefone atual, por favor, modifique o número.",
  "b18abc5de6": "Número de telefone não vinculado",
  "f5233dae6f": "Por favor, altere o número de telefone para criar",
  "4167c8b88d": "O número de telefone atual pode apresentar as seguintes situações. Por favor, tente alterar o número para criar. Se tiver dúvidas, entre em contato com o atendimento ao cliente.",
  "a8a2433c4d": "Adicione com QR Code do WeChat para consultar o atendimento ao cliente",
  "444a639c09": "Entendo",
  "69a097057f": "O número de telefone atual pertence a um segmento de operação virtual de telecomunicações <#BB2726>",
  "4370b06fd0": "O número de telefone atual apresenta comportamento de uso anormal <#BB2726>",
  "8c49e1dc4a": "É necessário realizar a verificação humano-máquina",
  "4b8ba7d8cc": "Nova plataforma de produtividade para escritório",
  "81be771e17": "🎉Empresa Criada Com Sucesso! Complete As Informações Para Obter Serviço Exclusivo",
  "461125b057": "Gerencie documentos e materiais na equipe. Membros da equipe podem visualizar facilmente e definir permissões de edição/download, garantindo a segurança dos dados",
  "c3eb25029b": "Tamanho da empresa/equipe",
  "049f8401ec": "Menos de 5 pessoas",
  "c81896349e": "6-20 pessoas",
  "7357daac4e": "21-50 pessoas",
  "f0e65a0a29": "51-100 pessoas",
  "b9fac8204a": "101-200 pessoas",
  "62d73dddaf": "201-500 pessoas",
  "3bcdaf7160": "501-2000 pessoas",
  "ab0b2333fe": "Mais de 2000 pessoas",
  "4f756eedc8": "Seu papel é",
  "3ba0b502c3": "Diretor Geral",
  "702099cc72": "Financeiro",
  "843b603162": "Compras",
  "8b414a9b44": "Recursos Humanos/Administração",
  "92486b2908": "Vendas",
  "ac4e7fb063": "Sua organização tem orçamento/planejamento para software de escritório",
  "37634c72dc": "Dentro de seis meses",
  "bd94b6deec": "Dentro de um ano",
  "713f4aad5c": "Considerando",
  "c5ea095a4d": "Sem planos",
  "2409099a69": "<img src=\"https://ks3-wpsplus-prod.wpscdn.cn/e2546275-3953-40b4-8933-9ff6f0a1aeb4.png\"> Crie Uma Equipe, Convide Membros Para Colaborar Juntos",
  "9d27dc2d90": "Insira o nome da sua equipe ou o projeto que está seguindo recentemente",
  "de19c8509a": "Você pode querer criar:",
  "1a84699223": "Departamento de Vendas",
  "efab59502b": "Departamento de Produtos",
  "7e599b3713": "Departamento de Operações do Sul",
  "bf494779c2": "Departamento de Compras",
  "f3a60ab34d": "Departamento Administrativo",
  "bbc50c1ac8": "Departamento Financeiro do Norte",
  "32629e3dac": "Departamento Financeiro de Produtos",
  "5524d354ba": "Departamento de TI",
  "0ccda29a0d": "🎁<span style='color: rgb(206,131,62);'>Você Desbloqueou Benefícios de Iniciante!</span> Convide Mais 3 Pessoas Para Receber <span style='color: rgb(206,131,62);'>4T de Espaço e WPS AI</span> Benefícios",
  "939eb98492": "<span style='color: rgb(206,131,62);'>Você Desbloqueou Limite de 50 Pessoas, 4G de Upload Máximo de Arquivo</span>. Continue Convidando 3 Pessoas Para Desbloquear 30 Dias de WPS AI e Benefícios de 4T de Espaço",
  "136c26d941": "Copie o link abaixo para convidar membros a se juntarem",
  "3de5c12558": "Copie o link, convide colegas",
  "a5d64b14f3": "Orientação de informação empresarial",
  "b8f2492701": "Coleta de informação empresarial",
  "1f9d053dc0": "Criar modelo de equipe",
  "0e83c79a88": "Convidar membros",
  "821fc1906a": "Entrar na empresa",
  "463e14ae9c": "Por favor, escolha a equipe",
  "690f0cdb9e": "Ícone de conclusão",
  "c340522a17": "Etapa anterior",
  "f9355c72ef": "Pular",
  "bd6c09ebbb": "Próxima etapa",
  "2a2603cd3f": "Envie convite por QR Code para colegas",
  "411e64907a": "Copiar",
  "b0d988cf23": "Transferir",
  "e3c0b650ac": "Cópia bem-sucedida",
  "713ac624b4": "Bem-vindo ao WPS 365",
  "b8fff97849": "Elemento alvo inválido",
  "02acdcf296": "Erro na conversão html2canvas, não gerou canvas",
  "a76988c496": "Falha ao converter canvas para blob",
  "af89584edf": "API da área de transferência não disponível",
  "f90263bbde": "Falha ao copiar imagem",
  "71b05319da": "Falha ao converter HTML para canvas",
  "38852999fe": "Falha ao salvar informações",
  "4a4c621d07": "Falha ao criar equipe, tente novamente mais tarde",
  "d239a23994": "Esta página está disponível apenas para contas empresariais, por favor, entre com uma conta empresarial primeiro.",
  "d93bfb7fb9": "Insira o conteúdo",
  "42b81a66c4": "Comprimento entre 2 a 100 caracteres",
  "76d33733db": "Não pode conter / \\ ; : * ? \" < > | % & e outros caracteres especiais",
  "dc55d1f62f": "Ir para Experiência",
  "b25233cba0": "Colaboração de Documentos + Comunicação Instantânea, Inicie Um Novo Estilo de Trabalho Eficiente",
  "f0e563652d": "<img src=\"https://vasvip-pub.wpscdn.cn/prod/SAAS-UG/atomic_guidance/icon/woa_logo_l.png\"> Inicie Chat de Colaboração em Grupo, Compartilhamento de Documentos Seguro e Conveniente",
  "1e484cce68": "<img src=\"https://vasvip-pub.wpscdn.cn/prod/SAAS-UG/atomic_guidance/icon/lingxi_normal.png\"> Assistente AI Lingxi, Um Assistente Inteligente Criado Para o Trabalho",
  "e338385bc9": "Agente Inteligente de Escritório Nativo, Integrando Profundamente AI e Software de Escritório para Dar a Todos um Assistente AI",
  "7ae1f3b1c6": "Importação de Arquivo(s) Concluída, Veja o Resultado em 'Meus Documentos na Nuvem'",
  "85db2a024a": "Erro na Importação de Arquivo(s), Tente Novamente Mais Tarde",
  "9ff74c802a": "Download da Versão para Processadores Intel",
  "ab44928f02": "Download da Versão para Processadores Apple",
  "a08d937c38": "Upload de Arquivo(s) em Andamento, Veja em 'Meus Documentos na Nuvem' Quando Concluído",
  "68db1829fa": "Apenas Suporta Importação de Conta Pessoal, Faça Login com sua Conta Pessoal e Tente Novamente.",
  "1185a7c7ab": "Até 20 Pessoas",
  "e2bcc252c9": "21-300 Pessoas",
  "3c4842f1ea": "301-1000 Pessoas",
  "1bbee64cfa": "Mais de 1000 Pessoas",
  "388ff4a035": "Professor",
  "d341b1d794": "Estudante",
  "bfb2ee4148": "Mais",
  "f6450c3f31": "Gestão de Projetos",
  "b87fd33a0d": "Plano Anual",
  "0dd45a1c14": "Gestão de Performance de Funcionários",
  "67fa01cac6": "Atividades de Marketing",
  "6dd82cc031": "Recrutamento de Funcionários",
  "a7edaed91d": "Materiais Didáticos",
  "bf12b7efb0": "Gestão de Planos de Ensino",
  "c35ae8f358": "Documentação do Produto",
  "343f236a78": "<img src=\"https://vasvip-pub.wpscdn.cn/prod/SAAS-UG/atomic_guidance/icon/dbsheet.png\"> WPS Planilha Multidimensional, Construa Visualmente o Sistema de Negócios Exclusivo",
  "72286d5519": "👏Modelo Recomendado",
  "0bc00ee949": "Gestão de Defeitos e Demandas",
  "e22f3d56f7": "Gestão de Criação de Conteúdo",
  "dd439de3dd": "Sistema de Gestão de Clientes",
  "fbb2bbf82e": "Plano de Estudos",
  "0645b908bc": "Consulta de Folha de Pagamento",
  "813b3d3d7e": "Gestão de OKR",
  "918e33d5bd": "Criar com Um Clique",
  "ebf9cfb7ef": "<img src=\"https://vasvip-pub.wpscdn.cn/prod/SAAS-UG/atomic_guidance/icon/import_files.png\"> Importe Documentos Comuns, Facilita o Uso",
  "c58f28713c": "Importar do Local",
  "9d6a0a4370": "Suporta Formatos Comuns de Arquivos do Office",
  "54c48aee85": "Escolher Arquivo",
  "c5b593e452": "Importar de Conta Pessoal",
  "4bdcd9d4c5": "Importar Documentos, Equipes e Pastas da Conta Pessoal com Um Clique",
  "99b2968905": "Importação Autorizada",
  "472f818a23": "<img src=\"https://vasvip-pub.wpscdn.cn/prod/SAAS-UG/atomic_guidance/icon/woa_logo_l.png\"> Baixar Cliente do WPS Teams",
  "fe46574227": "Colaboração de Documentos + Comunicação Instantânea, Nova Maneira de Trabalho Eficiente",
  "beefe5a09b": "Transferir Agora",
  "278839c7b1": "<img src=\"https://vasvip-pub.wpscdn.cn/prod/SAAS-UG/atomic_guidance/icon/woa_logo_l.png\"> Configurações de Segurança Ricas, Garantia da Segurança dos Dados",
  "b4e70dbeab": "Anos de Experiência em Segurança de Documentos do WPS para Garantir que Dados Críticos da Empresa Não Vazem",
  "42dc772619": "Arquivo Muito Grande, Importe na Página Inicial Mais Tarde",
  "a052564e47": "Erro ao Criar, Tente Novamente Mais Tarde"
}